module.exports = __webpack_public_path__ + "img/btn-bg-image1.6c396035.png";